module.exports = __webpack_public_path__ + "static/img/ale.fe3286b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ale.jpg
// module id = mY7/
// module chunks = 1